export default {
  name: 'assets',

  endpoints: [
    {
      method: 'GET',
      endpoint: '/info',
      hasParams: false,
      alias: 'info'
    },
    {
      method: 'GET',
      endpoint: '/types',
      hasParams: false,
      alias: 'types'
    },
    {
      method: 'GET',
      endpoint: '/client/:id',
      hasParams: true,
      alias: 'client'
    },
    {
      method: 'GET',
      endpoint: '/client/:id/grouped',
      hasParams: true,
      alias: 'clientGrouped'
    }
  ]
}
